import { handleActions } from 'redux-actions'
import { importPopupStatus } from 'actions/importPopup'

const defaultState = {
  open: false
}

const reducer = handleActions(
  {
    [importPopupStatus]: (
      state,
      {
        payload: {
          data: { status }
        }
      }
    ) => {
      return status
    }
  },
  defaultState
)

export default reducer
